import configService from '../services/config-service.js';

/**
 * Vue plugin to provide secure configuration service
 */
export default {
  install(app) {
    // Make config service available as $configService in all components
    app.config.globalProperties.$configService = configService;
    
    // Also provide it via provide/inject for composition API
    app.provide('configService', configService);
  }
};
